import Footer from './components/Footer';
import Header from './components/Header';
import Main from './pages/Main';

const App = () => {
	return (
		<>
			<Header />

			<Main />

			<Footer />
		</>
	);
};

export default App;
